import customFetch from '../services/fetch.js';

/**
 * Generates a unique identifier by combining the current timestamp
 * and a random string.
 *
 * @return {string} The generated unique identifier.
 */
function generateUniqueId() {
    const timestamp = Date.now().toString(36);
    const randomString = Math.random().toString(36).substr(2, 5);
    return timestamp + randomString;
}
const renderId = generateUniqueId();
const hostname = new URL(document.location.href).hostname;
const trackingPromotedSamplesOffer = async (siteId, customerId, samples, campaignId) => {
    const userId = getUserId();
    if (!userId) {
        return;
    }
    const trackingUrl = getTrackingUrl(siteId);
    const timestamp = new Date().toISOString();
    const payload = {
        customer_id: customerId,
        events: [
            {
                type: 'promoted_samples_offer',
                site_id: siteId,
                user_id: userId,
                timestamp: timestamp,
                render_id: renderId,
                campaign_id: campaignId,
                samples: samples,
            },
        ],
    };
    await customFetch(trackingUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
    });
};
const trackingSampleClicked = async (siteId, customerId) => {
    const userId = getUserId();
    if (!userId) {
        return;
    }
    const trackingUrl = getTrackingUrl(siteId);
    const timestamp = new Date().toISOString();
    const payload = {
        customer_id: customerId,
        events: [
            {
                type: 'sample_click',
                site_id: siteId,
                user_id: userId,
                timestamp: timestamp,
                render_id: renderId,
            },
        ],
    };
    await customFetch(trackingUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
    });
};
const trackingSampleAddedToCart = async (siteId, customerId, selectedSample, campaignId) => {
    const userId = getUserId();
    if (!userId) {
        return;
    }
    const trackingUrl = getTrackingUrl(siteId);
    const timestamp = new Date().toISOString();
    const payload = {
        customer_id: customerId,
        events: [
            {
                type: 'sample_added_to_cart',
                site_id: siteId,
                user_id: userId,
                campaign_id: campaignId,
                timestamp: timestamp,
                render_id: renderId,
                article_id: selectedSample.article_id,
                product_id: selectedSample.product_id,
            },
        ],
    };
    await customFetch(trackingUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
    });
};
const endpoints = {
    localStage: atob('aHR0cHM6Ly96b290b3BpYS10cmFja2luZy1kZXYucHJpdmF0ZS56b29wbHVzLm5ldC9ldmVudHMvc2l0ZXM='), //`https://zootopia-tracking-dev.private.zooplus.net/events/sites`,
    prodStage: `/zootopia-events/api/events/sites`,
};
const getTrackingUrl = (siteId) => {
    return `${getEndpoint()}/${siteId}`;
};
const getEndpoint = () => {
    const localRegex = /localhost|local/g;
    const isLocal = hostname.match(localRegex);
    if (isLocal) {
        return endpoints.localStage;
    }
    return endpoints.prodStage;
};
const getUserId = () => {
    return getCookie('zt_id');
};
const getCookie = (name) => {
    const cookiePairs = document.cookie.split(';');
    const cookieMap = {};
    for (const cookiePair of cookiePairs) {
        const [cookieName, value] = cookiePair.split('=');
        cookieMap[cookieName.trim()] = decodeURIComponent(value);
    }
    return cookieMap[name] || undefined;
};

export { trackingPromotedSamplesOffer, trackingSampleAddedToCart, trackingSampleClicked };
//# sourceMappingURL=tracking.js.map
